import API from './ks-engine'

const resource = 'dbs';

export default {
  get () {
    return API.get(`/${resource}`)
  }
}